<label class="items-per-page__label" for="paginatorItemsPerPage">Mostrar</label>
<select class="custom-select items-per-page__select" id="paginatorItemsPerPage" (change)="onChangeSelected($event.target.value)">
  <option *ngFor="let item of options" value="{{ item }}" [selected]="item === selected">
    {{ item }}
  </option>
</select>
<span class="items-per-page__label">de {{ results.length }} resultados</span>
